import {l} from "../../src/ts/debug/debug";

import { gsap } from "gsap/gsap-core";

export class SingleProduct {
    private readonly SELECTOR_TAB_LINK: string = ".single-product__details-pane-tab";
    private readonly SELECTOR_TABS_WRAPPER: string = ".single-product__details-pane-tabs-wrapper";
    private readonly SELECTOR_CONTENT_WRAPPER: string = ".single-product__details-pane";

    private readonly SELECTOR_GALLERY: string = ".single-product__image-gallery ul";
    private readonly SELECTOR_GALLERY_IMAGE: string = ".single-product__image-gallery-fullsize_image img";
    private readonly SELECTOR_GALLERY_NEXT_LINK: string = ".single-product__image-gallery-btn-next";
    private readonly SELECTOR_GALLERY_PREV_LINK: string = ".single-product__image-gallery-btn-prev";

    private readonly STATE_SELECTED_TAB: string = "selected";


    private $product: JQuery;
    private $productTabsWrapper: JQuery;
    private $productDetailsContentWrapper: JQuery;

    private $gallery: JQuery;
    private $fullsizeImageContainer: JQuery;
    private $galleryImages: HTMLCollection;
    private galleryImagesCount: number;
    private currentIndex: number = 0;
    private $galleryImagesNextButton: JQuery;
    private $galleryImagesPrevButton: JQuery;

    constructor($product: JQuery) {
        this.$product = $product;
        this.$productTabsWrapper = $(this.SELECTOR_TABS_WRAPPER);
        this.$productDetailsContentWrapper = $(this.SELECTOR_CONTENT_WRAPPER);
        this.$product.find(this.SELECTOR_TAB_LINK).on('click', (e) => this.onTabLinkClick(e));

        this.$gallery = this.$product.find(this.SELECTOR_GALLERY);

        if (this.$gallery && this.$gallery.length > 0) {
            this.$galleryImages = this.$gallery[0].children;
            for (let item in this.$galleryImages) {
                if( typeof(this.$galleryImages[item]) === 'object') {
                    this.$galleryImages[item].addEventListener('click', (e => this.setImage(e)));
                }
            }
            this.galleryImagesCount = this.$galleryImages.length;

            this.$fullsizeImageContainer = this.$product.find(this.SELECTOR_GALLERY_IMAGE);

            this.$galleryImagesNextButton = this.$product.find(this.SELECTOR_GALLERY_NEXT_LINK);
            this.$galleryImagesPrevButton = this.$product.find(this.SELECTOR_GALLERY_PREV_LINK);

            this.$galleryImagesNextButton.on('click', (e) => this.onGalleryNextClick(e));
            this.$galleryImagesPrevButton.on('click', (e) => this.onGalleryPrevClick(e));
        }
    }

    private onGalleryNextClick(e: JQuery.ClickEvent) {
        this.$galleryImages[this.currentIndex].classList.remove('selected');

        if (this.currentIndex + 1 < this.galleryImagesCount) {
            this.currentIndex++;
        } else {
            this.currentIndex = 0;
        }

        this.setImage();

        return false;
    }

    private onGalleryPrevClick(e: JQuery.ClickEvent) {
        this.$galleryImages[this.currentIndex].classList.remove('selected');

        if (this.currentIndex > 0) {
            this.currentIndex--;
        } else {
            this.currentIndex = this.galleryImagesCount - 1;
        }

        this.setImage();

        return false;
    }

    private setImage(el = null) {
        if (el !== null) {
            this.$galleryImages[this.currentIndex].classList.remove('selected');
            this.currentIndex = parseInt(el.currentTarget.dataset.index);
        }

        const current = this.$galleryImages[this.currentIndex];
        current.classList.add('selected');

        const orientation = current.getAttribute('data-orientation');
        const src = current.getAttribute('data-fullsize');
        const title = current.getAttribute('data-title');
        const alt = current.getAttribute('alt');

        gsap.to(this.$fullsizeImageContainer,
            {
                opacity: 0,
                duration: 0.2,
                onComplete: () => {
                    this.$fullsizeImageContainer.attr('src', src);
                    this.$fullsizeImageContainer.attr('alt', alt);
                    this.$fullsizeImageContainer.attr('data-orientation', orientation);
                    gsap.to(this.$fullsizeImageContainer, { opacity: 1, duration: 0.2 });
                }
            });
    }

    private onTabLinkClick(e: JQuery.ClickEvent) {

        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        const $linkButton = $(e.target);

        this.$productDetailsContentWrapper.children().hide();
        this.$productTabsWrapper.children().removeClass(this.STATE_SELECTED_TAB);

        $linkButton.addClass(this.STATE_SELECTED_TAB);


        const $linkTarget = $($linkButton.attr('href'));

        $linkTarget.show();

        return;
    }
}
